import { render, staticRenderFns } from "./fcBirthday.vue?vue&type=template&id=113634bd&"
import script from "./fcBirthday.vue?vue&type=script&lang=js&"
export * from "./fcBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports